import { useQuery } from '@apollo/react-hooks';
import { useMemo } from 'react';
import { SP_QueryStudentCards } from '~graphql/__generated__/SP_QueryStudentCards';
import { SP_QueryStudentViewer } from '~graphql/__generated__/SP_QueryStudentViewer';
import { QUERY_STUDENT_CARDS, QUERY_STUDENT_VIEWER } from '~graphql/user';

const useViewer = () => {
  const { data, refetch, loading } = useQuery<SP_QueryStudentViewer>(QUERY_STUDENT_VIEWER, {
    fetchPolicy: 'no-cache',
  });

  return useMemo(() => {
    return {
      viewer: data?.studentViewer,
      refetchViewer: refetch,
      loading,
    };
  }, [data, refetch, loading]);
};

export default useViewer;

export const useStudentCards = () => {
  const { data, refetch, loading } = useQuery<SP_QueryStudentCards>(QUERY_STUDENT_CARDS, {
    fetchPolicy: 'no-cache',
  });

  return useMemo(() => {
    return {
      studentCards: data?.studentViewer?.studentInfo?.cards,
      studentCardVaultStatus: data?.studentViewer?.studentInfo?.cardVaultStatus,
      refetchStudentCards: refetch,
      loading,
    };
  }, [data, refetch, loading]);
};
